/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Refineexamplewarmlight3Inputs */

const en_refineexamplewarmlight3 = /** @type {(inputs: Refineexamplewarmlight3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warm light`)
};

const de_refineexamplewarmlight3 = /** @type {(inputs: Refineexamplewarmlight3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warmes Licht`)
};

/**
* | output |
* | --- |
* | "Warm light" |
*
* @param {Refineexamplewarmlight3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const refineexamplewarmlight3 = /** @type {((inputs?: Refineexamplewarmlight3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Refineexamplewarmlight3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_refineexamplewarmlight3(inputs)
	return de_refineexamplewarmlight3(inputs)
});
export { refineexamplewarmlight3 as "refineExampleWarmLight" }